"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRUMInternalContext = exports.buildAssemble = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("./logger");
var reportRawError_1 = require("./reportRawError");
function buildAssemble(sessionManager, configuration, sender) {
    var _a;
    var reportAgentError = function (error) { return (0, reportRawError_1.reportRawError)(error, sender); };
    var logRateLimiters = (_a = {},
        _a[logger_1.StatusType.error] = (0, browser_core_1.createEventRateLimiter)(logger_1.StatusType.error, configuration.eventRateLimiterThreshold, reportAgentError),
        _a[logger_1.StatusType.warn] = (0, browser_core_1.createEventRateLimiter)(logger_1.StatusType.warn, configuration.eventRateLimiterThreshold, reportAgentError),
        _a[logger_1.StatusType.info] = (0, browser_core_1.createEventRateLimiter)(logger_1.StatusType.info, configuration.eventRateLimiterThreshold, reportAgentError),
        _a[logger_1.StatusType.debug] = (0, browser_core_1.createEventRateLimiter)(logger_1.StatusType.debug, configuration.eventRateLimiterThreshold, reportAgentError),
        _a['custom'] = (0, browser_core_1.createEventRateLimiter)('custom', configuration.eventRateLimiterThreshold, reportAgentError),
        _a);
    return function (message, currentContext) {
        var _a, _b;
        var startTime = message.date ? (0, browser_core_1.getRelativeTime)(message.date) : undefined;
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return undefined;
        }
        var contextualizedMessage = (0, browser_core_1.combine)({ service: configuration.service, session_id: session.id }, currentContext, getRUMInternalContext(startTime), message);
        if (((_a = configuration.beforeSend) === null || _a === void 0 ? void 0 : _a.call(configuration, contextualizedMessage)) === false ||
            ((_b = logRateLimiters[contextualizedMessage.status]) !== null && _b !== void 0 ? _b : logRateLimiters['custom']).isLimitReached()) {
            return undefined;
        }
        return contextualizedMessage;
    };
}
exports.buildAssemble = buildAssemble;
function getRUMInternalContext(startTime) {
    var rum = window.DD_RUM;
    return rum && rum.getInternalContext ? rum.getInternalContext(startTime) : undefined;
}
exports.getRUMInternalContext = getRUMInternalContext;
//# sourceMappingURL=assemble.js.map